import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { fetchSection } from "./services/api";

// Import translation files (used as defaults + offline fallback)
import enUS from "./locales/en-US.json";
import ptBR from "./locales/pt-BR.json";
import esES from "./locales/es-ES.json";

const resources = {
  "en-US": {
    translation: enUS,
  },
  "pt-BR": {
    translation: ptBR,
  },
  "es-ES": {
    translation: esES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "pt-BR", // default language
  fallbackLng: "pt-BR",

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

// Overlay any translations edited in the admin panel (stored in Cloudflare).
// Falls back silently to the bundled copies when nothing has been published.
export async function hydrateRemoteLocales(): Promise<void> {
  const langs: Array<[string, string]> = [
    ["pt-BR", "locale-pt-BR"],
    ["en-US", "locale-en-US"],
    ["es-ES", "locale-es-ES"],
  ];

  let changed = false;
  await Promise.all(
    langs.map(async ([lng, section]) => {
      const remote = await fetchSection<Record<string, unknown> | null>(
        section,
        null
      );
      if (remote) {
        i18n.addResourceBundle(lng, "translation", remote, true, true);
        changed = true;
      }
    })
  );

  // Nudge react-i18next to re-render with the freshly loaded resources.
  if (changed) {
    i18n.changeLanguage(i18n.language);
  }
}

export default i18n;
